import { Component } from '@angular/core';

@Component({
  selector: 'wl-why-get-protected',
  templateUrl: './why-get-protected.component.html',
  styleUrls: ['./why-get-protected.component.scss'],
})
export class WhyGetProtectedComponent {}
